var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('TheSnackbarQueueHandler'),_c('TheGlobalProgress'),_c('TheConfirmationDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }